import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Main from "./componets/main/Main";
import MoodMenu from "./componets/mood-menu/MoodMenu";
import MoodNote from "./componets/mood-note/MoodNote";
import AiPsychologist from "./componets/ai-psychologist/AiPsychologist";
import MoodResult from "./componets/mood-result/MoodResult";
import Achievement from "./componets/achievement/Achievement";
import MoodStreak from "./componets/mood-streak/MoodStreak";
import AiAnalysis from "./componets/ai-analysis/AiAnalysis";
import Statistics from "./componets/statistics/Statistics";
import Profile from "./componets/profile/Profile";
import TestList from "./componets/test/TestList";
import Test from "./componets/test/Test";
import News from "./componets/news/News";
import { useTelegram } from "./context/TelegramContext";
import { useEffect, useState } from "react";
import FullScreenPopup from "./componets/fullScreenPopup/FullScreenPopup";
import LanguageSwitcher from "./componets/languageSwitcher/LanguageSwitcher";
import { getUserRegistration } from "./api/mainApi";
import Guide from "./componets/guide/Guide";
import PremiumFull from "./componets/premium/PremiumFull";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Recap from "./componets/recap/Recap";
import MoodActivities from "./componets/mood-activities/MoodActivities";
import MeditationPlayer from "./componets/meditation/MeditationPlayer";
import TelegramBackButton from "./componets/telegram-back-button/TelegramBackButton";
import PremiumPopupManager from "./componets/premium/PremiumPopupManager";
import AddToHomeScreenManager from "./componets/addToHomeScreen/AddToHomeScreenManager";

function DeepLinkHandler() {
  const navigate = useNavigate();
  const tg = useTelegram();

  useEffect(() => {
    const startParam = tg?.initDataUnsafe?.start_param;
    const hasProcessedParam = sessionStorage.getItem("processed_start_param");

    // Якщо параметра немає або ми його вже обробили в цій сесії — перериваємо виконання
    if (!startParam || hasProcessedParam) return;

    // Записуємо в пам'ять, що параметр оброблено, щоб розблокувати навігацію
    sessionStorage.setItem("processed_start_param", "true");

    if (startParam === "premium") {
      navigate("/premium");
    } else if (startParam.startsWith("stories_")) {
      const groupId = startParam.replace("stories_", "");
      navigate(`/stories/${groupId}`);
    } else if (startParam.startsWith("test_")) {
      const testId = startParam.replace("test_", "");
      navigate(`/test/${testId}`);
    } else if (startParam.startsWith("recap_")) {
      const token = startParam.replace("recap_", "");
      navigate(`/recap-share/${token}`);
    } else if(startParam === "achievement") {
      navigate("achievement");
    }
    // else {
    //   navigate(`/${startParam.replace("_", "-")}`);
    // }
  }, [tg, navigate]);

  return null;
}

function App() {
  const tg = useTelegram();
  const { t } = useTranslation();

  useEffect(() => {
    if (!tg || typeof tg.lockOrientation !== "function") return;
    try {
      tg.lockOrientation();
    } catch (e) {
      console.warn("lockOrientation failed:", e);
    }
  }, [tg]);
  const [isPopupVisible, setIsPopupVisible] = useState(true);
  const startParam = tg?.initDataUnsafe?.start_param;
  const isRecapDeepLink = startParam && startParam.startsWith("recap_");
  const [language, setLanguage] = useState(
    localStorage.getItem("i18nextLng") || null,
  );
  const [guideCompleted, setGuideCompleted] = useState(() => {
    const stored = localStorage.getItem("guideCompleted");
    return stored === "true" || stored === true;
  });

  // if (!tg?.initDataUnsafe?.user) {
  //   return (
  //     <div className="h-screen flex flex-col items-center justify-center bg-gray-900 text-white text-center px-4">
  //       <p className="text-xl font-bold text-red-500">
  //         ⚠ {t("user_data_undefined")}
  //       </p>
  //       <p className="text-gray-400">{t("user_data_open_in")}</p>
  //       <a
  //         href="https://t.me/NirvanaMoodBot"
  //         className="mt-4 px-8 py-2 border rounded-xl text-white undreline-none"
  //       >
  //         Open in Telegram
  //       </a>
  //     </div>
  //   );
  // }

  if (language === null) {
    return (
      <div className="bg-gray-900">
        <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh flex flex-col items-center bg-gray-900 text-white text-center px-4">
          <LanguageSwitcher
            tg={tg}
            setLanguage={setLanguage}
            setGuideCompleted={setGuideCompleted}
          />
        </div>
      </div>
    );
  }

  if (
    guideCompleted !== true ||
    (!isRecapDeepLink && guideCompleted !== true)
  ) {
    return (
      <div className="bg-gray-900">
        <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh flex flex-col items-center bg-gray-900 text-white text-center">
          <Guide setGuideCompleted={setGuideCompleted} />
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App bg-gray-900">
        <TelegramBackButton />
        <PremiumPopupManager />
        <AddToHomeScreenManager />
        <DeepLinkHandler />
        <ToastContainer
          position="top-center"
          theme="colored"
          toastStyle={{ paddingTop: "80px" }}
        />
        {/* <div>
          {isPopupVisible && (
            <FullScreenPopup
              status="success"
              text="Операцію виконано успішно!"
              buttonText="Закрити"
              onClose={() => setIsPopupVisible(false)}
            />
          )}
        </div> */}
        {/* <p className="text-white">{telegram}</p> */}
        <Routes>
          {/* Окремий маршрут для MoodMenu */}

          <Route
            path="/mood-menu"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <MoodMenu />
              </div>
            }
          />
          <Route
            path="/mood-note"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <MoodNote />
              </div>
            }
          />
          <Route
            path="/mood-activities"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <MoodActivities />
              </div>
            }
          />
          <Route
            path="/mood-result"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <MoodResult />
              </div>
            }
          />
          <Route
            path="/achievement"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <Achievement />
              </div>
            }
          />
          <Route
            path="/ai-psychologist"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <AiPsychologist />
              </div>
            }
          />

          <Route
            path="/mood-streak"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <MoodStreak />
              </div>
            }
          />

          <Route
            path="/profile"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white flex flex-col">
                <Profile />
              </div>
            }
          />

          <Route
            path="/premium"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white flex flex-col">
                <PremiumFull />
              </div>
            }
          />

          <Route
            path="/test/:id"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white py-4 px-4 flex flex-col">
                <Test />
              </div>
            }
          />

          <Route
            path="/stories/:groupId"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white">
                <News />
              </div>
            }
          />

          <Route
            path="/recap"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white flex flex-col">
                <Recap />
              </div>
            }
          />

          <Route
            path="/recap-share/:token"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white flex flex-col">
                <Recap />
              </div>
            }
          />

          <Route
            path="/meditation-player/:id"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white flex flex-col">
                <MeditationPlayer />
              </div>
            }
          />

          {/* Усі інші маршрути (із меню) */}
          <Route
            path="*"
            element={
              <div className="w-full lg:w-1/3 xl:w-1/4 mx-auto h-dvh text-white px-4 flex flex-col">
                {/* Верхній блок */}
                <div className="flex-1 flex flex-col gap-y-4">
                  {/* Контент для основних сторінок */}
                  <Routes>
                    <Route path="/" element={<Main />} />
                  </Routes>
                  <Routes>
                    <Route path="/ai-analysis" element={<AiAnalysis />} />
                  </Routes>
                  <Routes>
                    <Route path="/statistics" element={<Statistics />} />
                  </Routes>
                  <Routes>
                    <Route path="/tests" element={<TestList />} />
                  </Routes>
                </div>

                {/* Нижнє меню */}
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
